import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDataService {

  constructor( private http : HttpClient, 
    private toast : ToastrService) { }

    getDataForInvoice(invoiceNumber : string){
      return this.http.get(environment.baseURl+ `/api/invoice/models/riq/${invoiceNumber}`);
    }
}
